<template>
  <Dropdown :dropdown-list="jobList" >
    <template v-slot="{ item }">
      <PtoJobCard
        :job="item"
        :disabled-remove="disabledRemove"
        @onRemove="onRemove"
      />
    </template>
  </Dropdown>
</template>

<script>
import PtoJobCard from '@/components/pto/Job/PtoJobCard'
import Dropdown from '@/components/page/Dropdown/Dropdown'

export default {
  name: 'DropdownJobList',
  components: { Dropdown, PtoJobCard },
  props: {
    jobList: {
      type: Array,
      required: true
    },
    disabledRemove: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onRemove (id) {
      this.$emit('onRemove', id)
    }
  }
}
</script>
